"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickupAttemptStatus = exports.OrderStatus = exports.DeliverCenters = exports.OrderType = exports.OrderPickUpDispute = void 0;
var OrderPickUpDispute;
(function (OrderPickUpDispute) {
    OrderPickUpDispute["None"] = "none";
    OrderPickUpDispute["SomeOneElseClaim"] = "SomeOneElseClaim";
    OrderPickUpDispute["InvalidPickup"] = "InvalidPickup ";
})(OrderPickUpDispute || (exports.OrderPickUpDispute = OrderPickUpDispute = {}));
var OrderType;
(function (OrderType) {
    OrderType["Gas"] = "Gas";
    OrderType["Product"] = "Product";
    OrderType["GasAndProduct"] = "Gas and Product";
})(OrderType || (exports.OrderType = OrderType = {}));
var DeliverCenters;
(function (DeliverCenters) {
    DeliverCenters["Company"] = "Urbanline_gas";
})(DeliverCenters || (exports.DeliverCenters = DeliverCenters = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NotPaid"] = "Not Paid";
    OrderStatus["Processing"] = "Processing";
    OrderStatus["Paid"] = "Paid";
    OrderStatus["Fail"] = "Failed";
    OrderStatus["Delivered"] = "Delivered";
    OrderStatus["Cancelled"] = "Cancelled";
    OrderStatus["ClientRejectPickup"] = "ClientRejectPickup";
    OrderStatus["StaffRejectPickup"] = "StaffRejectPickup";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var PickupAttemptStatus;
(function (PickupAttemptStatus) {
    PickupAttemptStatus["SUCCESS"] = "success";
    PickupAttemptStatus["FAILED"] = "failed";
    PickupAttemptStatus["BLOCKED"] = "blocked";
    PickupAttemptStatus["EXPIRED"] = "expired";
    PickupAttemptStatus["INVALID"] = "invalid";
    PickupAttemptStatus["PENDING"] = "pending";
})(PickupAttemptStatus || (exports.PickupAttemptStatus = PickupAttemptStatus = {}));
//# sourceMappingURL=order.js.map